import { Users } from "lucide-react";
import SettingsSection from "./SettingsSection";
import { useTeamMembers } from "../../hooks/useTeamMembers";
import { LoadingState, ErrorState, EmptyState } from "../ui/LoadingStates";

export default function TeamMembersSection({ onEdit, onInvite }) {
  // Use custom hook for fetching team members
  const { teamMembers, loading, error } = useTeamMembers(50, 0);

  return (
    <SettingsSection
      icon={Users}
      title="Team Members"
      description="Manage team access and permissions"
    >
      <div className="space-y-3">
        {loading ? (
          <LoadingState message="Loading team members..." size="small" />
        ) : error ? (
          <ErrorState message={error} />
        ) : teamMembers.length > 0 ? (
          // Team members list
          <>
            {teamMembers.map((member) => (
              <div
                key={member.id}
                className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
              >
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-medium text-gray-900">
                      {member.first_name} {member.last_name}
                    </p>
                    {!member.is_active && (
                      <span className="px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded">
                        Inactive
                      </span>
                    )}
                  </div>
                  <p className="text-sm">{member.email}</p>
                  <p className="text-xs text-gray-500 mt-1">
                    Role: {member.role || "User"}
                  </p>
                </div>
                {/* <button
                  onClick={() => onEdit(member)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Edit
                </button> */}
              </div>
            ))}
            {/* <button
              onClick={onInvite}
              className="w-full py-3 text-sm font-medium text-gray-600 border border-gray-200 border-dashed rounded-lg hover:bg-gray-50 transition-colors"
            >
              Invite Team Member
            </button> */}
          </>
        ) : (
          <EmptyState
            icon={Users}
            message="No team members yet"
            actionLabel="Invite First Team Member"
            onAction={onInvite}
          />
        )}
      </div>
    </SettingsSection>
  );
}
